import { Card, Table } from "antd";
import React, { FC } from "react";
import { StaffWithPerformance } from "../../entities/interfaces/analytics";
import DesignationTag, { DesignationValue } from "../misc/DesignationTags";
type Props = {
  data: StaffWithPerformance[];
};
const StaffPerfomanceComponent: FC<Props> = ({ data }) => {
  const byRevenueColumn = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
    },
    // {
    //   title: "Designation",
    //   key: "designation",
    //   render: (record: StaffWithPerformance) => (
    //     <DesignationTag value={record.designation as DesignationValue} />
    //   ),
    // },
    {
      title: "Total Amount",
      key: "totalAmount",
      sorter: (a: StaffWithPerformance, b: StaffWithPerformance) =>
        a.totalAmount - b.totalAmount,
      render: (record: StaffWithPerformance) => <p>{record.totalAmount}</p>,
    },
    {
      title: "Total Services",
      key: "totalServices",
      sorter: (a: StaffWithPerformance, b: StaffWithPerformance) =>
        a.totalServices - b.totalServices,
      render: (record: StaffWithPerformance) => <p>{record.totalServices}</p>,
    },
  ];

  return (
    <div className="grid grid-cols-12 gap-8">
      <div className="col-span-6">
        <Card
          bodyStyle={{ padding: "0.5rem" }}
          title="Staff Performance"
          headStyle={{ padding: "8px", minHeight: "30px" }}
        >
          <Table
            size="small"
            columns={byRevenueColumn}
            dataSource={data}
            pagination={false}
          />
        </Card>
      </div>
    </div>
  );
};

export default StaffPerfomanceComponent;
